import { useAuth0 } from '@auth0/auth0-react';
import React, { useEffect, useMemo } from 'react';
import { Outlet, useParams } from 'react-router-dom';

import { useAdmin } from '@/providers/AdminProvider.js';

import { ErrorPage, ErrorType } from '../pages/ErrorPage.js';
import type { AssetRouteParams } from '../pages/types.js';
import Loading from './Loading.js';

export const AuthGuard: React.FC = () => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const { isLoading: isAdminLoading, isAlveole, isPageAdmin } = useAdmin()

  const { assetSlug } = useParams<Partial<keyof AssetRouteParams>>();

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (!isAuthenticated) {
      void loginWithRedirect({ appState: { returnTo: window.location.href } });
    }
  }, [isLoading, isAuthenticated]);

  const canAccess = useMemo(() => {
    if (!assetSlug) {
      return true;
    }
    if (isAlveole) {
      return true;
    }
    return isPageAdmin;
  }, [assetSlug, isAlveole, isPageAdmin]);

  if (isLoading || isAdminLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Loading />
      </div>
    );
  }
  return isAuthenticated && canAccess ? <Outlet /> : <ErrorPage errorType={ErrorType.NoAccess} />;
};
